export default __webpack_public_path__ + "static/media/promo.f5438fd6.svg";